import { Api } from '@/api';
import ZIcon from '@/components/Icon';
import { Loading } from '@/components/Loading';
import { Message } from '@/components/Messsage';
import Modal from '@/components/Modal';
import axios from 'axios';
import React, { useRef, useState } from "react";
import './index.less';


interface Props{
    params?:any,
    trigger?:any
    $?:any
}

const Pdf = (props:Props)=>{

    const pdffile = useRef<any>();
    const serverPdfPath = useRef<string>();
    const [step,setStep] = useState(0);
    const [isDownLoad,setIsDownLoad] = useState(false);
    const [isAddLoaing,setIsAddLoading] = useState(0);


    const getFile = (e:any)=>{
        serverPdfPath.current = undefined;
        pdffile.current = undefined;
        const file  = e.target.files[0];
        pdffile.current  = e.target.files[0];
        let url = null;
        const win:any = window;
        if (win?.createObjcectURL != undefined) {
            url = win.createOjcectURL(file);
        } else if (win.URL != undefined) {
            url = win.URL.createObjectURL(file);
        } else if (win.webkitURL != undefined) {
            url = win.webkitURL.createObjectURL(file);
        }
        const PDFObJ: any = PDFObject;
        PDFObJ.embed(url, "#pdfslot");
        setStep(1)
    }


    const tencent = (err: any) => (
        <div className='text-center f18'>
            <div className='mt30 mb10'>{err.data.message || '系统繁忙，请稍后尝试'}</div>
            <div className='text-center w-100 color-red'>联系客服qq: 2579788799</div>
        </div>
    )
    const tencentBtn = <a className='color-white tencent-btn'
                          href="tencent://message/?uin=2579788799&Site=&Menu-=yes">联系客服</a>

    const doUpload = () => {
        console.log(pdffile)
        if (!pdffile.current) {
            Message.error('请上传PDF 文件');
            return;
        }
        const form: any = new FormData();
        form.append('file', pdffile.current)
        setIsAddLoading(1);
        Api.Tool.ChangePDF(form).then((res: any) => {
            setTimeout(() => {
                if (res.state) {
                    setIsAddLoading(2)
                    const PDFObJ: any = PDFObject;
                    PDFObJ.embed(res.data, "#pdfslot");
                    serverPdfPath.current = res.data;
                    setStep(2);
                    // Message.success('添加Made In China 成功!');
                    setTimeout(() => {
                        setIsAddLoading(0);
                    },500)
                }else{
                    Modal.tips(res.message)
                    setIsAddLoading(0)
                }
            },500)
        }).catch((err:any)=> {
            Modal.confirm({content: tencent(err), okText: tencentBtn})
            // Message.error('系统繁忙，请稍后尝试')
            console.log(err);
            setIsAddLoading(0)
        })
    }

    const  downLoadFile = ()=>{
        if(!pdffile.current){
            Modal.tips('请上传PDF 文件');
            return;
        }
        if(!serverPdfPath.current){
            Modal.tips('请添加Made In China');
            return;
        }
        setIsDownLoad(true)
        // 获取远端图片
        // alert(fileName)
        const serverFileName = serverPdfPath.current.split('\\').slice(-1)
        const [name] = pdffile.current.name.split('.pdf')
        axios({
            method:'get',
            url:`/api/top/deliverskill/DownloadPDF?fileName=${serverFileName}`,
            responseType: "blob",
        }).then((_res:any)=>{
            setIsDownLoad(false);
            let blob = new Blob([_res.data], {type: 'application/pdf'});
            let downloadElement:any = document.createElement("a");
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = `${name} 已添加Made In China.pdf`; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
        }).catch(err=>{
            setIsDownLoad(false)
        })
    }




    return (
        <div className='pdf_from'>
            <div className="pagenametag"> 在线一键添加Made in China</div>
            {step === 0 && <div className="pdf_step">
                <ul>
                    <li className={step == 0 ? "active" : ""}>
                        <i className="iconfont icon-shangchuan"/> 上传PDF文件 <span><img src="/images/jt.png"
                                                                                     alt=""/></span>
                    </li>
                    <li>
                        <i className="iconfont icon-tianjia"/> 点击添加 Made In China <em><img src="/images/jt.png" alt=""/></em>
                    </li>
                    <li><i className="iconfont icon-xiazai"/> 下载文件</li>
                    </ul>
                </div>}
                {step===0&&<div className="upload_file">
                    <div className="line">
                  <span className="span">
                  <input name="" type="text" id="viewfile" className="inputstyle" autoComplete='off' />
                  </span>
                        <label  className="search_btn_bj">点击选择PDF文件</label>
                        <img src="/images/add_img.png" alt=""/>
                        <input type="file" className="file" id="upload" onChange={getFile} accept="application/pdf" autoComplete='off'/>
                    </div>
                    <div className="pdf_info">
                        <p>① 内箱每个SKU产品和外箱每个FBA标签上，都均贴有“Made in china”标识，否则货物有可能被退回。</p>
                        <p>② 每个箱子至少贴2张以上FBA箱贴，防止其中一张损坏，而没有办法入库。</p>
                        <p>③ 若有问题请联系qq: <span className='color-red'>2579788799</span>。</p>
                    </div>
                </div>}

                <div className="pdf_view clearfix" style={{display:step===0?"none":""}} >
                    <div className="fr">
                        <button className="dl-input-wrap">
                            <input type='file' className="dl-input-cover" onChange={getFile} autoComplete='off' accept="application/pdf"/>
                            点击选择PDF文件
                        </button>
                        <button   className={step==1?"download_file":""} onClick={doUpload}>
                            {/* {isAddLoaing==1&&<Loading color={'white'}/>} */}
                            添加 Made in china
                        </button>

                        <button  className={step==2?"download_file":""} onClick={downLoadFile}>
                            {isDownLoad&&<Loading color={'#ff5e00'}/>}
                            下载文件
                        </button>
                    </div>
                    <div className="pdfMaskContent">
                        <div style={{zIndex:1,flex:1}}>
                            <div className="fl pdfcontent" id="pdfslot">
                            </div>
                        </div>
                        {isAddLoaing!=0&&<div className='pdfMask'>
                            {isAddLoaing==1&&<div className="flex flex-column justify-center align-items-center pdf-mask-content">
                                <Loading color={"#ff5e00"} className="pdf-mask-icon" />
                                <div style={{color:'white',marginTop:'10px'}}>正在添加Made in China...</div>
                            </div>}
                            {isAddLoaing==2&&<div className="flex flex-column justify-center align-items-center pdf-mask-content">
                                <ZIcon type={`icon-success`} className='pdf-mask-success-icon' style={{fontSize:'108px',opacity: 1}}/>
                                <div style={{color:'white',marginTop:'10px'}}>添加Made in China成功。</div>
                            </div>}
                        </div>}
                    </div>
                </div>
                {/* <div className="floatErrorUpload">
                  <ZIcon type="icon-error"  style={{color: 'white'}}/>
                  添加失败？
                  <br/>
                  立即上报
               </div> */}
            {/*</div>*/}
            <input type="text" style={{position: 'absolute',zIndex: -1,opacity: 0}}/>

        </div>
    )
}

export default Pdf
